// extracted by mini-css-extract-plugin
export default {"form":"ArticlePasswordDialog_form__y62vo"};